//首页
import homeApi from "./modules/home";
//商品api
import productApi from "./modules/product";
//账户模块
import accountApi from "./modules/account";
//公共模块
import commonApi from "./modules/common";
//用户api
import userApi from "./modules/user";
//购物车api
import cartApi from "./modules/cart";
//订单
import orderApi from "./modules/order";
//支付
import payApi from "./modules/pay";
//新闻
import newsApi from "./modules/news";
//活动
import activityApi from "./modules/activity";
export default {
    homeApi: homeApi,
    productApi: productApi,
    accountApi: accountApi,
    commonApi: commonApi,
    userApi: userApi,
    cartApi: cartApi,
    orderApi: orderApi,
    payApi: payApi,
    newsApi: newsApi,
    activityApi: activityApi,
};
